<template>
    <div class="integration-base">
        <router-view></router-view>
    </div>
</template>
  
<script>
export default {
    name: "integrationBase",
};
</script>